import React from 'react';
import { IconProps } from '.';

const SvgFolderCheckDouble = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m14.163 11.764-4.64 5.055-3.253-3.011 1.02-1.101 2.147 1.988 3.62-3.945 1.106 1.014ZM13.252 16.264l4.13-4.5-1.105-1.014-4.13 4.5 1.105 1.014Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='m10.401 3.25 2 3H22.75v14.5H1.25V3.25h9.151Zm.198 3-1-1.5H2.75v1.5h7.849ZM2.75 7.75v11.5h18.5V7.75H2.75Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgFolderCheckDouble;
